import { InvoiceParams, MultipleInvoiceResultsModel, getADIMultipleInvoices } from "@NA/Services/ADIInvoiceService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { invoiceParams } from "./ADIInvoiceHistoryHandler";

type HandlerType = CustomApiHandler<InvoiceParams, MultipleInvoiceResultsModel>;

export const DispatchADIMultipleInvoice: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/LoadADIMultipleInvoice",
        result: props.parameter,
    });
};

export const LoadADIMultipleInvoice: HandlerType = async (props: any) => {
    props.apiResult = await getADIMultipleInvoices(props.parameter);
};

export const DispatchCompleteLoadADIMultipleInvoice: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteADIMultipleInvoice",
        ADIMultipleInvoiceResult: props.apiResult,
    });
};

export const chain = [DispatchADIMultipleInvoice, LoadADIMultipleInvoice, DispatchCompleteLoadADIMultipleInvoice];

const loadADIMultipleInvoices = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        ...invoiceParams,
        customerSequence: "ALL",
    },
    "loadADIMultipleInvoices",
);
export default loadADIMultipleInvoices;
